import { Link } from "react-router-dom";

export const LAZ_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_laz-connect/artifacts/zcfm76ym_Screenshot_20250903_090007_Google.jpg";

export const PARTNER_LOGOS = [
  {
    name: "Youth Leadership Movement",
    tagline: "Changing · Serving · Transforming",
    url: "https://customer-assets.emergentagent.com/job_laz-connect/artifacts/wpjnc10d_2024-06-22.webp",
  },
  {
    name: "La Zoube Global",
    tagline: "Local Service & International",
    url: "https://customer-assets.emergentagent.com/job_laz-connect/artifacts/a0emqet2_IMG-20260615-WA0008.jpg",
  },
];

export default function LazLogo({ size = 40, withText = true, to = "/", className = "" }) {
  const inner = (
    <>
      <div
        className="rounded-2xl bg-white border border-stone-200 overflow-hidden shrink-0 shadow-sm"
        style={{ width: size, height: size }}
      >
        <img
          src={LAZ_LOGO_URL}
          alt="LAZ Coach"
          className="w-full h-full object-cover"
          draggable="false"
        />
      </div>
      {withText && (
        <div className="leading-none">
          <div className="font-serif text-xl text-stone-900">LAZ Coach</div>
          <div className="text-[10px] tracking-[0.22em] text-stone-500 uppercase mt-0.5">
            Executive & Life Coaching
          </div>
        </div>
      )}
    </>
  );

  if (!to) {
    return <div className={`flex items-center gap-2 ${className}`}>{inner}</div>;
  }
  return (
    <Link to={to} className={`flex items-center gap-2 ${className}`} data-testid="laz-logo">
      {inner}
    </Link>
  );
}
